// src/PlatForms/SelfLMS/Hooks/Courses/useCourseDetails.js
import { useState, useEffect } from 'react';
import { selfLearnerService } from 'PlatForms/SelfLMS/Services/Courses/CourseService';


const useCourseDetails = (courseId) => {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCourseDetails = async () => {
    if (!courseId) {
      setError('Course ID is required');
      setLoading(false);
      return;
    }

    try {
      console.log('............. Fetching course details for ID:', courseId);
      setLoading(true);
      setError(null);

      const data = await selfLearnerService.getCourseDetails(courseId);
      console.log(' Course details received:', data);

      setCourse(data);
    } catch (err) {
      console.error(' Error fetching course details:', err);
      setError(err.response?.data?.message || err.message || 'Failed to fetch course details');
      setCourse(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (courseId) {
      fetchCourseDetails();
    }
  }, [courseId]);

  const refetch = () => {
    fetchCourseDetails();
  };

  return {
    course,
    loading,
    error,
    refetch
  };
};

export default useCourseDetails;